import type { AnyRoute } from "@tanstack/react-router";

import { createRoute } from "@tanstack/react-router";

import { HomePage } from "./page";

export function buildHomeRoute(parentRoute: AnyRoute) {
  return createRoute({
    getParentRoute: () => parentRoute,
    path: "/",
    component: HomePage
  });
}
